import { ReactNode } from "react";
import classNames from "classnames";
import SkeletonBox from "src/components/SkeletonBox/SkeletonBox";
import { DisclaimersSkeleton, FlightSelectionSkeleton, PassengerTileSkeleton, SSRTypeSelectionSkeleton } from "./SSR.skeleton.shared";

export default function SSRSkeletonWeb({ stepButtons }: { stepButtons?: ReactNode }) {
  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex w-full flex-col justify-between gap-4 lg:flex-row lg:items-center">
        <div className="flex flex-col gap-1">
          <SkeletonBox className="h-7 w-56 md:h-8" />
          <SkeletonBox className="h-4 w-80 max-w-full md:h-5" />
        </div>
        <SSRTypeSelectionSkeleton />
      </div>

      <div className="flex max-h-120 w-full flex-col gap-4 overflow-hidden rounded-md bg-background-default p-4">
        <FlightSelectionSkeleton />
        <div className="flex w-full flex-col items-start justify-between gap-x-8 gap-y-4 md:flex-row md:flex-wrap">
          <div className="flex w-full flex-col gap-4 px-2 md:flex-1">
            <SkeletonBox className="h-7 w-36" />
            <div className="flex flex-col gap-2">
              {[0, 1].map((i) => (
                <div
                  key={i}
                  className={classNames(
                    "flex items-center rounded-xs bg-background-default p-4 outline-1",
                    i === 0 ? "outline-border-active" : "outline-border-subtle",
                  )}
                >
                  <PassengerTileSkeleton />
                </div>
              ))}
            </div>
          </div>
          <div className="w-full min-w-60 md:flex-2">
            <SkeletonBox className="h-96 w-full rounded-xl" />
          </div>
          <DisclaimersSkeleton />
        </div>
      </div>

      <div className="flex w-full items-center justify-between gap-4 rounded-md bg-background-default px-6 outline outline-border-subtle">
        <div className="flex flex-wrap items-center gap-3 py-4">
          <SkeletonBox className="h-5 w-20" />
          {[0, 1, 2].map((i) => (
            <SkeletonBox key={i} className="h-6 w-32 rounded-full" />
          ))}
        </div>
        <div className="shrink-0">{stepButtons}</div>
      </div>
    </div>
  );
}
